// navSynonyms - what people CALL a page, as opposed to what we named it.
//
// Adam could not find his alert configuration because the menu said
// "Review Rules" and he was looking for alerting. The page was never
// broken; it was unfindable. Renaming it to Alert Rules fixed that one
// item. This fixes the class: search matches a page by what it DOES.
//
// Keyed by the nav item id from NAV_GROUPS, so adding words here never
// touches that array and never changes a label anybody has learned.
//
// Rules for adding to this file:
//  - write the words a CUSTOMER would type, not our internal vocabulary
//  - include the old name of anything we have renamed, so muscle memory
//    keeps working after a rename
//  - the key MUST be a nav item id from NAV_GROUPS. synonymsFor() is only
//    ever called with one, so a key that is an `also` route (eu-ai-act,
//    exposure, deploypolicies) or a page with no nav entry (agentmap) never
//    matched anything. Four such keys sat here unnoticed; their words were
//    folded into the owning entry and the keys are marked RETIRED rather
//    than removed, so nobody re-adds them. gen-surfaces --check now fails
//    the build on a key that is not an id.
//  - do not repeat words already in the label; the label is matched
//    separately and duplicating it here just makes the file harder to
//    keep honest

export const NAV_SYNONYMS = {
  // Admin
  govrules:      'alerts alerting notify notification notifications threshold thresholds email escalation review rules',
  connections:   'connect credentials secret api key tenant azure aws gcp dataverse power platform onboarding setup',
  integrations:  'connect app marketplace webhook',
  siem:          'splunk sentinel log stream export forwarding syslog',
  users:         'people team members invite invitation seats roles permissions rbac access',
  security:      'sso mfa saml session password login authentication',
  billing:       'invoice subscription plan payment upgrade seats licence license',
  branding:      'logo colours colors theme white label whitelabel customise customize',
  account:       'profile me my settings password',
  help:          'support contact ticket question',
  implguide:     'onboarding getting started setup steps rollout',

  // Home / executive
  exposurescore: 'score posture rating band overall health grade risk score',
  starthere:     'what to do next actions recommendations priorities todo',
  dashboard:     'home overview summary',
  execboard:     'board directors trustees governance report',
  execcaio:      'chief ai officer',
  execcio:       'chief information officer',
  execciso:      'chief information security officer security leadership',
  execcfo:       'finance cost spend budget chief financial officer',
  execcfoval:    'finance value roi return benefit',
  execcro:       'risk officer chief risk',
  zerotrust:     'zta never trust verify segmentation',

  // Discover
  inventory:     'shadow ai apps tools catalogue catalog what we use assets endpoints desktops collector',
  discovery:     'scan find detect shadow unknown',
  agents:        'copilots bots assistants llm models gpt claude gemini graph topology diagram relationships blast radius',
  // RETIRED agentmap - synonymsFor() is only ever called with a nav item id;
  nhi:           'machine identity service principal service account non human credentials secrets certificates expiry',

  // Assess
  exposurepaths: 'attack path lethal trifecta chain blast radius egress',
  govregister:   'register catalogue catalog record of processing',
  risks:         'risk register issues findings',
  owasp:         'owasp agentic llm top 10 asi prompt injection genai security', // G360_K557
  myagents:      'mine owned by me my bots',
  behrisk:       'behaviour behavior user risk insider anomaly ueba',
  dataposture:   'data classification sensitive pii labels dlp posture',
  vendors:       'third party supplier vendor due diligence tprm',

  // Cost
  tokengov:      'tokens spend budget quota consumption limits forecast',
  copilotconsum: 'microsoft copilot credits consumption m365 usage licences licenses',

  // Govern
  purposereg:    'purpose signed declaration intended use scope justification',
  archreview:    'architecture design review approval gate',
  supervision:   'oversight human in the loop hitl monitoring',
  accessreq:     'request approval grant permission ask',
  routingrules:  'approver routing workflow who approves escalation',
  incidents:     'incident breach event response postmortem',

  // Enforce
  policies:      'rules guardrails controls block redact allow deny tool app assign',
  datashield:    'dlp redaction masking sensitive data protection leak prevention',
  mcpgw:         'mcp model context protocol gateway tools tool grants proxy',
  // RETIRED deploypolicies - synonymsFor() is only ever called with a nav item id;
  purview:       'microsoft purview labels sensitivity compliance portal',
  deploy:        'extension browser endpoint install force install intune gpo rollout desktop agent guard push distribute publish rollout',
  coverage:      'enforced how much protected reach percentage guard enforcing working',

  // Prove
  compliance:    'controls evidence framework soc2 iso nist audit readiness refresh eu ai act article annex high risk regulation europe enforcement',
  // RETIRED euaiact - synonymsFor() is only ever called with a nav item id;
  // RETIRED exposure - synonymsFor() is only ever called with a nav item id;
  reports:       'pdf export download report generate exposure summary',
  audit:         'audit trail log history who did what evidence chain',
};

// One flat, lowercased string per item id - built once, not per keystroke.
export function synonymsFor(id) {
  return NAV_SYNONYMS[id] || '';
}
